function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { MarkdownSize, breakpointTypes } from '@vtblife/react-markdown-types';
import { useMemo } from 'react';
export function useMarkdownBreakpointsSettings(_ref) {
  var _ref$minimalHeadingSt = _ref.minimalHeadingStyleLevel,
    _minimalHeadingStyleLevel = _ref$minimalHeadingSt === void 0 ? 1 : _ref$minimalHeadingSt,
    sizeVariant = _ref.sizeVariant,
    breakpoints = _ref.breakpoints,
    footnote = _ref.footnote,
    _ref$colorVariant = _ref.colorVariant,
    colorVariant = _ref$colorVariant === void 0 ? 'white' : _ref$colorVariant,
    paddingSize = _ref.paddingSize;
  var breakpointsSettings = useMemo(function () {
    var settings = {
      renderersBreakpoints: {
        l: {},
        m: {},
        s: {},
        xl: {},
        xs: {}
      },
      classNamesBreakpoints: {
        l: {},
        m: {},
        s: {},
        xl: {},
        xs: {}
      }
    };
    if (breakpoints) {
      var _iterator = _createForOfIteratorHelper(breakpointTypes),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var breakpoint = _step.value;
          settings.renderersBreakpoints[breakpoint].minimalHeadingStyleLevel = breakpoints[breakpoint].minimalHeadingStyleLevel || _minimalHeadingStyleLevel;
          settings.classNamesBreakpoints[breakpoint].colorVariant = breakpoints[breakpoint].colorVariant || colorVariant;
          settings.classNamesBreakpoints[breakpoint].paddingSize = breakpoints[breakpoint].paddingSize || paddingSize;
          settings.classNamesBreakpoints[breakpoint].sizeVariant = breakpoints[breakpoint].sizeVariant || sizeVariant;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return settings;
    }
    var _iterator2 = _createForOfIteratorHelper(breakpointTypes),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _breakpoint = _step2.value;
        var minimalHeadingStyleLevel = _minimalHeadingStyleLevel;
        if (sizeVariant === MarkdownSize.PersonalAreaSmall && minimalHeadingStyleLevel < 5) {
          minimalHeadingStyleLevel = 5;
        } else if ((sizeVariant === MarkdownSize.Small || footnote) && minimalHeadingStyleLevel < 4) {
          minimalHeadingStyleLevel = 4;
        } else if ((sizeVariant === MarkdownSize.Medium || sizeVariant === MarkdownSize.PersonalAreaMedium) && minimalHeadingStyleLevel < 3) {
          minimalHeadingStyleLevel = 3;
        }
        settings.renderersBreakpoints[_breakpoint].minimalHeadingStyleLevel = minimalHeadingStyleLevel;
        settings.classNamesBreakpoints[_breakpoint].colorVariant = colorVariant;
        settings.classNamesBreakpoints[_breakpoint].paddingSize = paddingSize;
        settings.classNamesBreakpoints[_breakpoint].sizeVariant = sizeVariant;
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return settings;
  }, [_minimalHeadingStyleLevel, breakpoints, footnote, colorVariant, paddingSize, sizeVariant]);
  return breakpointsSettings;
}